import { useCallback, useRef } from 'react'

import { history } from '~/helpers'
import useQueryParams from '~/hooks/useQuery'

/**
 * Reescreve a querystring a partir da atual e navega. Lê os params pelo
 * router (não por `location`), mas devolve uma função estável para callbacks
 * que sobrevivem a renders (debounce, painel lateral).
 */
export const usePushSearchParams = () => {
  const params = useQueryParams()
  const paramsRef = useRef(params)
  paramsRef.current = params

  return useCallback((mutate: (next: URLSearchParams) => void) => {
    const next = new URLSearchParams(paramsRef.current.toString())

    mutate(next)
    history.push({ search: next.toString() })
  }, [])
}
